import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { CustomLabelInputType, CustomPrintLabelForBill, GeneralConfigType, KeyValueId, KeyValueSet, LocalService, NumericConfig, ReceiptCustomeLabelReplace, ReceiptOption, Status } from 'src/service/local.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-custom-label-print-config',
  templateUrl: './custom-label-print-config.component.html',
  styleUrl: './custom-label-print-config.component.scss'
})
export class CustomLabelPrintConfigComponent {
  @ViewChild('content_custom_label_print_config')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  ReceiptOption = ReceiptOption; CustomLabelInputType = CustomLabelInputType;

  @Input() businessId: string = ''; @Input() languageId: string = '';
  @Input() id: string = ''; @Input() isCanEdit: boolean = false; @Input() printerTemplateId: string = '';
  @Input() replaceLabels: KeyValueId[] = []; @Input() customFields: KeyValueSet[] = []; @Input() customLabelInputTypes: KeyValueSet[]
  isLabelSelected: boolean = false;

  item: CustomPrintLabelForBill; receiptOptions: KeyValueSet[] = [];
  selectedReceiptOption = ''; selectedReceiptReplaceLabel = '';
  customStyles: KeyValueSet[] = []; numericConfig: NumericConfig = { isDecimalAllowed: true, isNegativeAllowed: true } as NumericConfig;

  elementIds: any = {
    save: "btn_custom_label_print_config_save",
    title: 'txt_custom_label_print_config_title',
    disp_name: 'txt_custom_label_print_config_disp_name',
    value: 'txt_custom_label_print_config_value',
    label: 'txt_custom_label_print_config_label',
    group_by: 'txt_custom_label_group_by'
  };

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private printerService: PrinterService, private configurationManagementService: ConfigurationManagementService) {
  }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {
    if (!this.localService.receiptOptions) {
      this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.ReceiptOption, true).subscribe(result => {
        this.localService.receiptOptions = result;
        this.onSetReceiptOptions();
      });
    } else {
      this.onSetReceiptOptions();
    }
  }


  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    if (this.businessId && this.businessId.length > 5 && this.languageId && this.languageId.length > 5) {
      this.printerService.getCustomLabelPrintById(this.id).subscribe(result => {
        this.item = result;
        this.onSetCustomStyles();
        this.selectedReceiptOption = this.item.receiptOption && this.item.receiptOption > 0 ? this.item.receiptOption.toString() : '';
        this.selectedReceiptReplaceLabel = this.item.receiptCustomeLabelReplace && this.item.receiptCustomeLabelReplace > 0 ? this.item.receiptCustomeLabelReplace.toString() : '';
        this.onLabelSelected();
      });
    }
  }

  onSetCustomStyles() {
    this.customStyles = [];
    this.localService.CustomStyleNames.forEach(customStyleName => {
      switch (customStyleName.s_value) {
        case 'boolean': {
          customStyleName.isSelected = this.item.customStyle[customStyleName.key] && this.item.customStyle[customStyleName.key] == true ? true : false;
        } break;
        case 'number': {
          customStyleName.value = this.item.customStyle[customStyleName.key] && this.item.customStyle[customStyleName.key] != 0 ? this.item.customStyle[customStyleName.key] : 0;
        } break;
      }
      this.customStyles.push(customStyleName);
    });
  }

  onGetCustomStyles() {
    this.customStyles.forEach(customStyle => {
      switch (customStyle.s_value) {
        case 'boolean': {
          this.item.customStyle[customStyle.key] = customStyle.isSelected && customStyle.isSelected == true ? true : false;
        } break;
        case 'number': {
          this.item.customStyle[customStyle.key] = customStyle.value && parseFloat(customStyle.value) != 0 ? parseFloat(customStyle.value) : 0;
        } break;
      }
    });
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onSave();
      } break;
    }
  }

  onSave() {
    if (this.businessId && this.businessId.length > 5 && this.languageId && this.languageId.length > 5) {
      this.item.receiptOption = this.selectedReceiptOption && this.selectedReceiptOption.length > 0 ? parseInt(this.selectedReceiptOption) : 0;

      this.item.receiptCustomeLabelReplace = this.selectedReceiptReplaceLabel && this.selectedReceiptReplaceLabel.length > 0 ? parseInt(this.selectedReceiptReplaceLabel) : 0;
      this.item.printerTemplateId = this.printerTemplateId;
      this.onGetCustomStyles();
      this.printerService.saveCustomLabelPrint(this.businessId, this.languageId, this.item).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          this.onCloseTrigger();
        }
      });
    }
  }

  onSetReceiptOptions() {
    //const elligibleReceiptOptions: ReceiptOption[] = [ReceiptOption.AdjustmentRoundOff, ReceiptOption.AllotmentNumber, ReceiptOption.AppointmentToken, ReceiptOption.BillStatus, ReceiptOption.CompanyAddress, ReceiptOption.CompanyContactNumber, ReceiptOption.CompanyName, ReceiptOption.ComputerGeneratedInvoice, ReceiptOption.CustomerName, ReceiptOption.DateTime, ReceiptOption.DeliveryAddress, ReceiptOption.DeliveryMethod, ReceiptOption.Disclaimer, ReceiptOption.EMail, ReceiptOption.FSSAI, ReceiptOption.GSTIN, ReceiptOption.GrandTotal, ReceiptOption.LicenceNumber, ReceiptOption.ModeOfPayment, ReceiptOption.PaidAmount, ReceiptOption.PoweredBy, ReceiptOption.QR_Code, ReceiptOption.ReceiptNumber, ReceiptOption.RemainingAmount, ReceiptOption.ServiceBy, ReceiptOption.TotalLineNumber, ReceiptOption.TotalQuantity, ReceiptOption.WebSite, ReceiptOption.WelcomeMessage, ReceiptOption.ItemCode, ReceiptOption.ItemName, ReceiptOption.ItemQuantity, ReceiptOption.UnitPrice, ReceiptOption.ItemTotalCost, ReceiptOption.HsnCode, ReceiptOption.SacCode, ReceiptOption.CompanySGST, ReceiptOption.CompanyCGST, ReceiptOption.CompanyIGST, ReceiptOption.CustomField, ReceiptOption.BillNumber, ReceiptOption.BillAndTokenNumber];

    //this.receiptOptions = this.localService.receiptOptions.filter(x => elligibleReceiptOptions.includes(parseInt(x.key)));
    this.receiptOptions = this.localService.receiptOptions;
  }

  onLabelSelected() {
    this.isLabelSelected = false;
    if (this.selectedReceiptReplaceLabel && parseInt(this.selectedReceiptReplaceLabel) > 0) {
      const receiptReplaceLabel = parseInt(this.selectedReceiptReplaceLabel);
      this.isLabelSelected = ReceiptCustomeLabelReplace[receiptReplaceLabel]?.endsWith('_Label');
    }
  }
}
